import type { ConcreteDataType } from '@thinkalpha/language-services';
import type { TemplateColumn } from '@thinkalpha/ui-types/contracts/column-template';
import type { SlugMapDict } from 'src/lib/dictionary/dictionary';

/**
 * Ensure that an imported indicator by slug is present in the output columns
 */
export function ensureColumnBySlugWithName(
    /**
     * SlugMap is used to retrieve indicators to construct the output columns
     */
    slugMap: SlugMapDict,

    /**
     * The columns list to modify
     */
    columns: TemplateColumn[],

    /**
     * The indicator to ensure is a column
     */
    slugColumn: {
        name: string;
        slug: keyof SlugMapDict;
    },
): TemplateColumn[] {
    const indicator = slugMap[slugColumn.slug];

    if (!indicator) return columns;
    if (indicator.disabled) return columns;

    if (
        columns.find((col) => {
            if (col.type !== 'indicator') return false;

            return col.indicator.id === indicator.id;
        })
    ) {
        return columns;
    }

    const newColumn: TemplateColumn = {
        type: 'indicator',
        indicator,
        id: indicator.id,
        name: slugColumn.name,
        unit: typeof indicator.unit === 'string' ? indicator.unit : null,
        visible: false,
        dataType: indicator.dataType as ConcreteDataType,
        displaySettings: [],
    };

    return [...columns, newColumn];
}

/**
 * Ensure that columns from a column template include columns for a certain set of matchSlugs.
 */
export function ensureColumns(
    /**
     * SlugMap is used to retrieve indicators to construct the output columns.
     */
    slugMap: SlugMapDict,

    /**
     * The columns to ensure.
     */
    columns: TemplateColumn[],

    /**
     * The matchSlugs to ensure.
     */

    slugs: (keyof SlugMapDict)[],
): TemplateColumn[] {
    let returnColumns = columns;

    for (const slug of slugs) {
        const indicator = slugMap[slug];

        if (!indicator) continue;

        returnColumns = ensureColumnBySlugWithName(slugMap, returnColumns, { name: indicator.name, slug });
    }

    return returnColumns;
}
